import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/auth';
import { handlAuthUserType } from '../../../reducersAndActions/actions/authAction';
import styles from './Footer.module.scss';

function Footer() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [, dispatch] = useAuth();

  const hyperlinks = [
    { text: 'Edit business details', id: 'editBusiness' },
    { text: 'User feedback', id: 'user' },
    { text: 'Raise a complaint', id: 'business' },
    { text: 'Upgrade your business', id: 'business' },
  ];
  const handleLinkType = (item) => {
    if (item.id === 'editBusiness') {
      handlAuthUserType(dispatch, 'business');
      navigate('/csportal/faq/Edit-my-Business?vertical=&footerFlag=1');
    } else {
      handlAuthUserType(dispatch, item?.id || '');
      navigate(`/csportal?type=${item.id}`);
    }
  };
  // const toggleDrawer = () => {
  //   setIsOpen(!isOpen);
  // };
  return (
    <div className={`${styles.Drawer} pt-15 pb-15 pr-20 pl-20`}>
      <div className={`${styles.DrawerHead}  ${isOpen ? `${styles.Active}` : ''}`}>
        <div className="font13 fw500 color111 pr-10">
          Get Customer Care & Support Services for India’s No. 1 Local Search Engine Justdial
        </div>
        <div
          aria-label="Toggle drawer"
          tabIndex={0}
          role="button"
          onKeyDown={() => {}}
          className={`${styles.DrawerIcon} csicon`}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      {isOpen && (
        <div className={`${styles.DrawerContent}`}>
          <ul className={`${styles.DrawerList} mt-5`}>
            {hyperlinks.map((item, index) => (
              <li className={`${styles.DrawerItem} Whitefill_animate font12 fw400 color111`} key={index}>
                <div
                  aria-label="payment_redirection"
                  tabIndex={0}
                  role="button"
                  onKeyDown={() => {}}
                  onClick={() => handleLinkType(item)}
                >
                  {item.text}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default Footer;
